const EventEmitter = require('eventemitter3');
export default class AndroidEventEmitter extends EventEmitter{

}